/* eslint-disable */
const Fetch_ACCOUNT = 'Fetch_ACCOUNT';
const Update_ACCOUNT = 'Update_ACCOUNT';

const initialState = {};

export const fetchAccount = (payload) => ({
  type: Fetch_ACCOUNT,
  payload,
});

export const updateAccount = (payload) => ({
  type: Update_ACCOUNT,
  payload,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Fetch_ACCOUNT:
      return action.payload || initialState;
    case Update_ACCOUNT:
      return {
        ...state,
        ...(action.payload || {}),
      };
    default:
      return state;
  }
};

export default reducer;